<template>
    <div ref="compare" style="width:100%;height:100%;">
        <l-map ref="compareMap" style="z-index: 0;background-color: black" :options="option" ></l-map>
    </div>
</template>

<script>

import L from 'leaflet';
import {LMap} from 'vue2-leaflet';
import '@/lib/side-by-side/leaflet-side-by-side'


export default {
    name: "CompareVertical",
    components: {LMap,},
    props:["topLayerCite","bottomLayerCite","bounds","compareFullScreen"],
    data() {
        return {
            option: {zoomControl: false, attributionControl: false, renderer: L.canvas(),zoomSnap:0.01,},
        }
    },
    methods: {
      addLayer(){
        this.$refs.compareMap.mapObject.setMinZoom(0)
        let topLayer = L.tileLayer('https://tile.charmingglobe.com/map/dataset/' + this.topLayerCite + '/{z}/{x}/{y}?token=Bearer%20a84a40c81f784490a4c5689187054abf',{tms:true}).addTo(this.$refs.compareMap.mapObject);
        let bottomLayer = L.tileLayer('https://tile.charmingglobe.com/map/dataset/' + this.bottomLayerCite + '/{z}/{x}/{y}?token=Bearer%20a84a40c81f784490a4c5689187054abf',{tms:true}).addTo(this.$refs.compareMap.mapObject)
        L.control.sideBySide(bottomLayer,topLayer).addTo(this.$refs.compareMap.mapObject);
        this.$refs.compareMap.mapObject.fitBounds(L.geoJSON(JSON.parse(this.bounds)).getBounds())
        this.$refs.compareMap.mapObject.setMaxBounds(L.geoJSON(JSON.parse(this.bounds)).getBounds())
        this.$refs.compareMap.mapObject.setMinZoom(this.$refs.compareMap.mapObject.getZoom() +  0.1)
      },
      //水平卷帘修改样式，默认是垂直的
      setStyle(){
        //垂直模式
        document.getElementsByClassName("leaflet-sbs-range")[0].style.width = this.$refs.compare.clientHeight + "px";
        document.getElementsByClassName("leaflet-sbs-range")[0].style.height = this.$refs.compare.clientWidth + "px";
        document.getElementsByClassName("leaflet-sbs-range")[0].style.transform = "rotate(90deg) translateY(" + this.$refs.compare.clientHeight/2 + "px)"
        document.getElementsByClassName("leaflet-sbs-range")[0].style.top = this.$refs.compare.clientHeight/2 - this.$refs.compare.clientWidth/2 + "px";
      },
      zoomIn(){
        this.$refs.compareMap.mapObject.zoomIn(0.5)
      },
      zoomOut(){
        this.$refs.compareMap.mapObject.zoomOut(0.5)
      },
      drawPolyline()
      {
        //设置样式
        let myStyle = {
          "color": "red",
          "weight": 2,
          "opacity": 0.5,
          "fillColor": 'red',
          "fillOpacity": 0,
        };
        //geojson数据
        let someFeatures =[
          {
            "type":"FeatureCollection",
            "features":[
              {
                "type":"Feature",
                "id":"CHN",
                "properties":{
                  "name":"China"
                },
                "geometry":JSON.parse(this.bounds)}]}]


        //渲染方法
        L.geoJSON(someFeatures, {
          style: myStyle,
        }).addTo(this.$refs.compareMap.mapObject);
      }
    },
    mounted() {
      this.addLayer()
      this.setStyle()
    },
}
</script>
